import { useLang } from '@/i18n';
import EfProductCompareC from '@elem/ui/ef-product-compare-c';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionE');
    const listA = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724211423906/ups.png',
        h5: '',
        title: t('win_a_title'),
        desc: t('win_a_desc'),
        specList: [
            {
                title: t('win_a_item1_t'),
                desc: t('win_a_item1_b'),
            },
            {
                title: t('win_a_item2_t'),
                desc: t('win_a_item2_b'),
            },
            {
                title: t('win_a_item3_t'),
                desc: t('win_a_item3_b'),
            },
            {
                title: t('win_a_item4_t'),
                desc: t('win_a_item4_b'),
            },
            {
                title: t('win_a_item5_t'),
                desc: t('win_a_item5_b'),
            },
            {
                title: t('win_a_item6_t'),
                desc: t('win_a_item6_b'),
            },
        ],
    };

    const listB = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724211308828/sl_r3.png',
        h5: '',
        title: t('win_b_title'),
        desc: t('win_b_desc'),
        specList: [
            {
                title: t('win_b_item1_t'),
                desc: t('win_b_item1_b'),
            },
            {
                title: t('win_b_item2_t'),
                desc: t('win_b_item2_b'),
            },
            {
                title: t('win_b_item3_t'),
                desc: t('win_b_item3_b'),
            },
            {
                title: t('win_b_item4_t'),
                desc: t('win_b_item4_b'),
            },
            {
                title: t('win_b_item5_t'),
                desc: t('win_b_item5_b'),
            },
            {
                title: t('win_b_item6_t'),
                desc: t('win_b_item6_b'),
            },
        ],
    };

    const listAll = [listA, listB];
    return (
        <div className={styles.WinA}>
            <EfProductCompareC items={listAll} theme="transparent" />
        </div>
    );
}
